import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as themes from '../../constants/theme';
import withTheme from '../withTheme/withTheme';

import './sticky-toolbar.scss';

const TOOLBAR_CLASS_NAME = 'has-sticky-toolbar';

class StickyToolbar extends React.Component {
    componentDidMount() {
        document.body.classList.add(TOOLBAR_CLASS_NAME);
    }

    componentWillUnmount() {
        document.body.classList.remove(TOOLBAR_CLASS_NAME);
    }

    render() {
        const { children, theme } = this.props;
        const toolbarClassName = classNames('sticky-toolbar', {
            [`sticky-toolbar--${theme}`]: true,
        });

        return (
            <React.Fragment>
                <div className={toolbarClassName} ref={this.stickyToolbarRef}>
                    <div className="sticky-toolbar__container">
                        {children}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

StickyToolbar.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    theme: PropTypes.oneOf(Object.values(themes)),
};

StickyToolbar.defaultProps = {
    theme: themes.PRIVATE,
};

export const ThemedStickyToolbar = withTheme(StickyToolbar);

StickyToolbar.Themed = ThemedStickyToolbar;

export default StickyToolbar;
